import { FloatingPortal } from '@floating-ui/react';
import { FC, ReactNode } from 'react';

interface DropdownPortalProps {
    children: ReactNode;
}

const DropdownPortal: FC<DropdownPortalProps> = (props) => {
    const { children } = props;

    return <FloatingPortal root={document.getElementById('dropdown-root')}>{children}</FloatingPortal>;
};

export default DropdownPortal;
